import { render, staticRenderFns } from "./AuthorizerEdit.vue?vue&type=template&id=7d433769&"
import script from "./AuthorizerEdit.vue?vue&type=script&lang=js&"
export * from "./AuthorizerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports